import {
  CardContent, CardMedia,
  Tab,
  Tabs,
  Paper,
  Button,
  Box,
  tabsClasses,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  Card
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { IDadosPropostas, IDadosReverterProposta, PropostaService } from "../../services/api/propostas/PropostaService";
import { moedaRealLocaleValue } from "../input-valor-moeda/Current-Mask";
import { DialogMensagem, IDadosModal } from "./DialogMensagem";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";
import { ChangeCircle } from "@mui/icons-material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    maxWidth: '800px',
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    maxWidth: '800px',
  },
  '& .MuiDialog-paper': {
    maxWidth: '800px',
  },
  '& .MuiGrid-container': {
    overflow: 'hidden'
  }
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}
function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export type IModalDadosDetalheProps = {
  mensagem: string;
  label: string;
  titulo: string;
  codigoProposta: number;
  reverter: boolean;
  acao: boolean;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
export type IModalDetalhesProps = {
  dados: IModalDadosDetalheProps;
  isModalVisible: boolean;
  onBackClickClose: () => void;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                <Box sx={{ p: 1 }}>
                    <Grid>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}

function a11yProps(index: number) {

  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}



export const ModalDetalhesProposta: React.FC<IModalDetalhesProps> = ({ dados, onBackClickClose, isModalVisible }) => {
  const [open, setOpen] = React.useState(isModalVisible);
  const [valueTab, setValueTabRodada] = useState(0);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [lstDadosPropostaCabecalho, setLstDadosPropostaCabecalho] = useState<IDadosPropostas[]>([]);
  const [lstDadosPropostaCabecalhoRecebe, setLstDadosPropostaCabecalhoRecebe] = useState<IDadosPropostas[]>([]);
  const [imagemPicks, setImagemPicks] = useState<any>("../../../picks.png");
  const [imagemPicksProtegida, setImagemPicksProtegida] = useState<any>("../../../lock2.png");
  const [imagemSwap, setImagemSwap] = useState<any>("../../../swap5.png");
  const [imagemMulta, setImagemMulta] = useState<any>("../../../multas.png");
  const [semImagem, setSemImagem] = useState<any>("../../../semimagemescudo.png");
  const [removeLoading, setRemoveLoading] = useState(false);
  const [showModalMensagem, setShowModalMensagem] = useState(false);

  const [dadosModal, setDadosModal] = useState<IDadosModal>({
    acao: false,
    label: "",
    tipo: "error",
    mensagem: "Sessão Expirada!",
    display: "none",
    titulo: "Atenção"
  });

  const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
  const formatNumber = new Intl.NumberFormat('pt-BR', options);

  useEffect(() => {
    setRemoveLoading(false);
    const fetchData = async () => {
      if (dados.codigoProposta > 0) {
        await PropostaService.getPorCodigo(Number(dados.codigoProposta))
          .then((result) => {
            setIsLoading(false);
            let dadosProposta = result.dado;
            let lstItensPropostas = dadosProposta.dados_Proposta;
            dadosProposta.franquias.forEach(f => {

              let obj = {
                codigo: f.codigo_Proposta,
                logo_Franquia_Envia: f.logo,
                codigo_Franquia_Envia: f.codigo,
                nome_Franquia_Envia: f.nome,
                nome_General_Manager_Envia: f.nome_General_Manager,
                situacao: f.situacao,
                dados_Propostas: lstItensPropostas
              }
              lstDadosPropostaCabecalho.push(obj);
            });
            dadosProposta.franquias.forEach(f => {
              let obj = {
                codigo: f.codigo_Proposta,
                logo_Franquia_Recebe: f.logo,
                codigo_Franquia_Recebe: f.codigo,
                nome_Franquia_Recebe: f.nome,
                nome_General_Manager_Recebe: f.nome_General_Manager,
                situacao: f.situacao,
                dados_Propostas: lstItensPropostas
              }
              lstDadosPropostaCabecalhoRecebe.push(obj);

            });
            setRemoveLoading(true);
          })
          .catch((errors) => {
            setRemoveLoading(true);
            setShowModalMensagem(true);
            if (errors.response.data.statusHTTP === 401) {
              setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              return;
            }
            if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
              setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
              return;
            }
            else {
              setDadosModal({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Não foi possível carregar os dados da proposta! Favor entrar em contato com a TI",
                display: "none",
                titulo: "Atenção"
              });
              return;
            }
          });
      }
    }

    fetchData();
  }, [dados.codigoProposta]);

  const toggleModalMensagem = () => {
    setShowModalMensagem(modalVisivel => !modalVisivel);
  };

  const handleChangeTabsRodadas = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabRodada(newValue);
  };

  if (!isModalVisible) {
    return null;
  }
  const handleClickOpen = () => {
    setOpen(true);
    onBackClickClose();
  };
  const handleClose = () => {
    setOpen(false);
    onBackClickClose();
  };

  const handleReverterProposta = async () => {
    //codigo da proposta
    // codigo usuario logado

    let dadosReverter: IDadosReverterProposta = {
      codigo: Number(dados.codigoProposta),
      codigo_Usuario: 0
    }
    await PropostaService.updateReverter(dadosReverter)
      .then((result) => {

        setShowModalMensagem(true);
        setDadosModal({
          acao: true,
          label: "",
          tipo: "success",
          mensagem: "Proposta revertida com sucesso!",
          display: "none",
          titulo: "Atenção"
        });
        setTimeout(() => {
          setIsLoading(false);
          setRemoveLoading(true);
          navigate(0);
        }, 2500);


      })
      .catch((errors) => {
        setRemoveLoading(true);
        setShowModalMensagem(true);
        if (errors.response.data.statusHTTP === 401) {
          setDadosModal({
            acao: true,
            label: "",
            tipo: "info",
            mensagem: "Sessão expirada!",
            display: "none",
            titulo: "Atenção"
          });
          return;
        }
        if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
          setDadosModal({
            acao: true,
            label: "",
            tipo: "info",
            mensagem: errors.response.data.mensagem,
            display: "none",
            titulo: "Atenção"
          });
          return;
        }
        else {
          setDadosModal({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível reverter a proposta! Favor entrar em contato com a TI",
            display: "none",
            titulo: "Atenção"
          });
          return;
        }
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>{dados.mensagem}</Button>
      {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
      <BootstrapDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"

      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          {dados.mensagem}
        </BootstrapDialogTitle>
        <DialogContent dividers >
          {/* <Box sx={style}> */}
          <Grid container size={12} padding={1} spacing={2}>
            <Grid container size={12} display={dados.reverter ? "block" : "none"} >
              <Grid size={{ xs: 12, sm: 3 }}>
                <Button
                  color="primary"
                  variant="contained"
                  disableElevation
                  onClick={() => handleReverterProposta()}
                  startIcon={<ChangeCircle />}
                >
                  Reverter
                </Button>
              </Grid>
            </Grid>
            <Grid container size={12} direction="column" sx={{ minWidth: UtilidadeService.isMobile() ? "314px" : "400px" }}>
              <Paper style={{ padding: 0 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={valueTab}
                    onChange={handleChangeTabsRodadas}
                    variant="scrollable"
                    scrollButtons
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        '&.Mui-disabled': { opacity: 0.3 },
                      },
                    }}
                  >
                    <Tab label="Envia"  {...a11yProps(0)} />
                    <Tab label="Recebe" {...a11yProps(1)} />
                  </Tabs>
                </Box>
                <TabPanel value={valueTab} index={0}>
                  {!isLoading && lstDadosPropostaCabecalho.length > 0 ?
                    UtilidadeService.isMobile() ?
                      (
                        <Grid container spacing={2}  >
                          {lstDadosPropostaCabecalho.map((cab, i) => (
                            <Grid key={`Grid1${i}`} container style={{ padding: 0 }} size={{ xs: 12, sm: 12 }} margin={1} sx={{ backgroundColor: "#28292b" }} >
                              <Grid container size={{ xs: 12, sm: 12 }} padding={0} margin={1} display="flex" direction="column" maxHeight={UtilidadeService.isMobile() ? 60 : 135}>
                                <Grid size={{ xs: 12, sm: 4 }} paddingLeft={1} paddingRight={1}>
                                  <img src={cab.logo_Franquia_Envia}
                                    alt={cab.nome_Franquia_Envia}
                                    width={UtilidadeService.isMobile() ? 65 : 130} height={UtilidadeService.isMobile() ? 65 : 130}
                                  />
                                </Grid>
                                <Grid container size={{ xs: 12, sm: 8 }} paddingLeft={1} paddingRight={1} width={UtilidadeService.isMobile() ? "70%" : "92%"}>
                                  <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography variant='h5' style={{ fontSize: UtilidadeService.isMobile() ? 16 : 24 }} fontWeight="bold">
                                      {cab.nome_Franquia_Envia}
                                    </Typography>
                                  </Grid>
                                  <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography variant='body1' style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                      {cab.nome_General_Manager_Envia}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1}>
                                <hr />
                              </Grid>
                              {cab.dados_Propostas.filter(f => f.codigo_Franquia_Envia === cab.codigo_Franquia_Envia).length > 0 ? cab.dados_Propostas.filter(f => f.codigo_Franquia_Envia === cab.codigo_Franquia_Envia).map((prop, i) => (
                                <Grid container size={{ xs: 12, sm: 12 }} display="flex" direction="row" >
                                  <Grid key={`Grid${i}`} size={{ xs: 12, sm: 12, md: 12 }} margin={1} padding={0}  >
                                    <Card key={`Card${i}`} >
                                      <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                        <Grid size={{ xs: 12, sm: 12 }}>
                                          <CardContent sx={{ paddingBottom: 1 }} >
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} >
                                              <Grid size={{ xs: 3, sm: 4, md: 4 }} padding={0}>
                                                <img src={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                  prop.tipo_Ativo === 3 ? imagemMulta : imagemPicks}
                                                  alt={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                    prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks}
                                                  width={UtilidadeService.isMobile() ? 50 : 130} height={UtilidadeService.isMobile() ? 50 : 130}
                                                />
                                              </Grid>
                                              <Grid size={{ xs: 9, sm: 8, md: 8 }} display="flex" justifyContent="center" alignItems="center" alignSelf="center" padding={1} >
                                                {(prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2) && (
                                                  <Box width="100%" height={UtilidadeService.isMobile() ? "80px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        {prop.tipo_Ativo === 1 ? prop.nome_Jogador : prop.nome_Jogador_Dispensa}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        R${prop.valor_Jogador !== undefined ? moedaRealLocaleValue(prop.valor_Jogador) : "0"}
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        {prop.tempo_Contrato_Jogador !== undefined ? prop.tempo_Contrato_Jogador + " ano(s)" : "0 ano"}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Recebe} RECEBE
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                                {prop.tipo_Ativo === 3 && prop.tipo_Multa !== 1 && (
                                                  <Box width="100%" height={UtilidadeService.isMobile() ? "80px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        Multa: {cab.nome_Franquia_Envia}
                                                      </Typography>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        Valor:  {prop.valor_Multa !== undefined ? "R$ " + moedaRealLocaleValue(prop.valor_Multa) : prop.valor_Multa}
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        Ano:  {prop.descricao_Temporada_Multa}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Recebe} RECEBE
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                                {prop.tipo_Ativo === 3 && prop.tipo_Multa === 1 && (
                                                  <Box width="100%" height={UtilidadeService.isMobile() ? "80px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        Multa: {cab.nome_Franquia_Envia}
                                                      </Typography>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        Jogador:  {prop.nome_Jogador_Multa?.split("-")[0]}
                                                      </Typography>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        Valor:  {`${prop.nome_Jogador_Multa?.split("-")[1]} / ${prop.quantidade_Anos_Multa}`}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 6, sm: 12 }}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Recebe} RECEBE
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                                {prop.tipo_Ativo === 4 && (
                                                  <Box width="100%" height={UtilidadeService.isMobile() ? "80px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        Pick: {prop.posicao_Final !== undefined && prop.posicao_Final > 2 ?
                                                          prop.posicao_Final
                                                          : prop.rodada_Pick !== undefined && prop.rodada_Pick === 1 ? "First" : "Second"}
                                                      </Typography>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        {"Ano: " + prop.ano_Pick}
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        {prop.nome_Franquia_Envia}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Recebe} RECEBE
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                              </Grid>
                                              <Grid container size={{ xs: 12, sm: 3 }} display={"flex"} justifyContent={"start"} style={{ marginTop: -25, paddingLeft: "5px" }}>
                                                <img src={prop.logo_Franquia_Recebe === null ? semImagem : prop.logo_Franquia_Recebe} alt={prop.nome_Franquia_Recebe} width={UtilidadeService.isMobile() ? 40 : 100} height={UtilidadeService.isMobile() ? 40 : 100} />
                                              </Grid>
                                            </Grid>
                                          </CardContent>
                                        </Grid>
                                      </Grid>
                                    </Card>
                                  </Grid>
                                </Grid>
                              ))
                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" margin={2} >
                                  <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }} sx={{ color: "#CD1E03" }}>Esta franquia não possui itens a enviar, nessa proposta. </Typography>
                                </Grid>
                              }
                            </Grid>
                          ))}
                        </Grid>) : (
                        <Grid container spacing={2}  >
                          {lstDadosPropostaCabecalho.map((cab, i) => (
                            <Grid key={`Grid1${i}`} container size={{ xs: 12, sm: 12 }} margin={1} sx={{ backgroundColor: "#28292b" }} >
                              <Grid container size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1} margin={1} display="flex" direction="column" maxHeight={135}>
                                <Grid size={{ xs: 12, sm: 4 }} paddingLeft={1} paddingRight={1}>
                                  <img src={cab.logo_Franquia_Envia}
                                    alt={cab.nome_Franquia_Envia}
                                    width={130} height={130}
                                  />
                                </Grid>
                                <Grid container size={{ xs: 12, sm: 8 }} paddingLeft={1} paddingRight={1} width="92%">
                                  <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography variant='h5' fontWeight="bold">
                                      {cab.nome_Franquia_Envia}
                                    </Typography>
                                  </Grid>
                                  <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography variant='body1'>
                                      {cab.nome_General_Manager_Envia}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1}>
                                <hr />
                              </Grid>
                              {cab.dados_Propostas.filter(f => f.codigo_Franquia_Envia === cab.codigo_Franquia_Envia).length > 0 ? cab.dados_Propostas.filter(f => f.codigo_Franquia_Envia === cab.codigo_Franquia_Envia).map((prop, i) => (
                                <Grid container size={{ xs: 12, sm: 12 }} display="flex" direction="row">
                                  <Grid key={`Grid${i}`} size={{ xs: 12, sm: 12, md: 12 }} margin={1} >
                                    <Card key={`Card${i}`} >
                                      <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                        <Grid size={{ xs: 12, sm: 3 }} alignSelf="center" padding={1}>
                                          <CardMedia
                                            component="img"
                                            alt={(prop.codigo_Franquia_Envia + i).toString()}
                                            height="120"
                                            width="150"
                                            image={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                              prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks
                                            }
                                            key={`CardMedia${i}`}
                                            sx={{ objectFit: "fill" }}
                                          />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 9 }}>
                                          <CardContent sx={{ padding: 1, paddingBottom: 1 }} >
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                              <Grid size={{ xs: 12, sm: 9, md: 9 }} display="flex" justifyContent="center" alignItems="center" alignSelf="center" padding={1} >
                                                {(prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2) && (
                                                  <Box width="100%" height="150px" display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6">
                                                        {prop.tipo_Ativo === 1 ? prop.nome_Jogador : prop.nome_Jogador_Dispensa}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="body1" >
                                                        R${prop.valor_Jogador !== undefined ? moedaRealLocaleValue(prop.valor_Jogador) : "0"}
                                                      </Typography>
                                                      <Typography variant="body1" >
                                                        {prop.tempo_Contrato_Jogador !== undefined ? prop.tempo_Contrato_Jogador + " ano(s)" : "0 ano"}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Recebe} RECEBE
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                                {prop.tipo_Ativo === 3 && prop.tipo_Multa !== 1 && (
                                                  <Box width="100%" height="150px" display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6">
                                                        Multa: {cab.nome_Franquia_Envia}
                                                      </Typography>
                                                      <Typography variant="h6" >
                                                        Valor:  {prop.valor_Multa !== undefined ? "R$ " + moedaRealLocaleValue(prop.valor_Multa) : prop.valor_Multa}
                                                      </Typography>
                                                      <Typography variant="body1" >
                                                        Ano:  {prop.descricao_Temporada_Multa}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Recebe} RECEBE
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                                {prop.tipo_Ativo === 3 && prop.tipo_Multa === 1 && (
                                                  <Box width="100%" height="150px" display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6">
                                                        Multa: {cab.nome_Franquia_Envia}
                                                      </Typography>
                                                      <Typography variant="h6" >
                                                        Jogador:  {prop.nome_Jogador_Multa?.split("-")[0]}
                                                      </Typography>
                                                      <Typography variant="h6" >
                                                        Valor:  {`${formatNumber.format(Number(prop.valor_Multa))} / ${prop.quantidade_Anos_Multa}`}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Recebe} RECEBE
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                                {prop.tipo_Ativo === 4 && (
                                                  <Box width="100%" height="150px" display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6">
                                                        Pick: {prop.posicao_Final !== undefined && prop.posicao_Final > 2 ?
                                                          prop.posicao_Final
                                                          : prop.rodada_Pick !== undefined && prop.rodada_Pick === 1 ? "First" : "Second"}
                                                      </Typography>
                                                      <Typography variant="h6" >
                                                        {"Ano: " + prop.ano_Pick}
                                                      </Typography>
                                                      <Typography variant="body1" >
                                                        {prop.nome_Franquia_Envia}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Recebe} RECEBE
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                                {prop.tipo_Ativo === 5 && (
                                                  <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        Melhor Pick: {prop.nome_Franquia_Recebe}
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        Picks Envolvidas
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        * {prop.primeira_Pick_Swap}
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        * {prop.terceira_Pick_Swap}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Envia} ENVIA
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                                {prop.tipo_Ativo === 6 && (
                                                  <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                    <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        Melhor Pick: {prop.nome_Franquia_Recebe}
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        Picks Envolvidas II
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        * {prop.primeira_Pick_Swap !== undefined ? prop.primeira_Pick_Swap : prop.rodada_Pick === 1 ? "First " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick : "Second " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick}
                                                      </Typography>
                                                      <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                        * {prop.segunda_Pick_Swap !== undefined ? prop.segunda_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap}
                                                      </Typography>
                                                      {prop.inicio_Protecao !== undefined && prop.inicio_Protecao > 0 && prop.fim_Protecao !== undefined && prop.fim_Protecao > 0 && (
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          {`* (${prop.inicio_Protecao} - ${prop.fim_Protecao})  ${prop.terceira_Pick_Swap !== undefined ? prop.terceira_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao}`}
                                                        </Typography>
                                                      )}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                        {prop.nome_Franquia_Envia} ENVIA
                                                      </Typography>
                                                    </Grid>
                                                  </Box>
                                                )}
                                              </Grid>
                                              <Grid container size={{ xs: 12, sm: 3 }}>
                                                <Grid size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" justifySelf="center" textAlign="center">

                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" justifySelf="center" alignItems="center">
                                                  <img src={prop.logo_Franquia_Recebe === null ? semImagem : prop.logo_Franquia_Recebe} alt={prop.nome_Franquia_Recebe} width={100} height={100} />
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </CardContent>
                                        </Grid>
                                      </Grid>
                                    </Card>
                                  </Grid>
                                </Grid>
                              ))
                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" margin={2} >
                                  <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }} sx={{ color: "#CD1E03" }}>Esta franquia não possui itens a enviar, nessa proposta. </Typography>
                                </Grid>
                              }
                            </Grid>
                          ))}
                        </Grid>
                      )
                    : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Nenhuma proposta encontrada </Typography>
                      <hr />
                    </Grid>
                  }
                </TabPanel>
                <TabPanel value={valueTab} index={1}>
                  {!isLoading && lstDadosPropostaCabecalhoRecebe.length > 0 ?
                    UtilidadeService.isMobile() ?
                      (
                        <Grid container spacing={2}  >
                          {lstDadosPropostaCabecalhoRecebe.map((cab, i) => (
                            <Grid container size={{ xs: 12, sm: 12 }} style={{ padding: 0 }} margin={1} sx={{ backgroundColor: "#28292b" }} >
                              <Grid container size={{ xs: 12, sm: 12 }} padding={0} margin={1} display="flex" direction="column" maxHeight={UtilidadeService.isMobile() ? 60 : 135}>
                                <Grid size={{ xs: 12, sm: 4 }} paddingLeft={1} paddingRight={1}>
                                  <img src={cab.logo_Franquia_Recebe}
                                    alt={cab.nome_Franquia_Recebe}
                                    width={UtilidadeService.isMobile() ? 65 : 130} height={UtilidadeService.isMobile() ? 65 : 130}
                                  />
                                </Grid>
                                <Grid container size={{ xs: 12, sm: 8 }} paddingLeft={1} paddingRight={1} width={UtilidadeService.isMobile() ? "70%" : "92%"}>
                                  <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography variant='h5' style={{ fontSize: UtilidadeService.isMobile() ? 16 : 24 }} fontWeight="bold">
                                      {cab.nome_Franquia_Recebe}
                                    </Typography>
                                  </Grid>
                                  <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography variant='body1' style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                      {cab.nome_General_Manager_Recebe}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1}>
                                <hr />
                              </Grid>
                              {cab.dados_Propostas.filter(f => f.codigo_Franquia_Recebe === cab.codigo_Franquia_Recebe).length > 0
                                ? cab.dados_Propostas.filter(f => f.codigo_Franquia_Recebe === cab.codigo_Franquia_Recebe).map((prop, i) => (
                                  <Grid key={`Grid1${i}`} container size={{ xs: 12, sm: 12 }} display="flex" direction="row">
                                    <Grid key={`Grid${i}`} size={{ xs: 12, sm: 12, md: 12 }} margin={1} >
                                      <Card key={`Card${i}`} >
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                          <Grid size={{ xs: 12, sm: 12 }}>
                                            <CardContent sx={{ paddingBottom: 1 }} >
                                              <Grid container size={{ xs: 12, sm: 12, md: 12 }} >
                                                <Grid size={{ xs: 3, sm: 4, md: 4 }} padding={0}>
                                                  <img src={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                    prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks}
                                                    alt={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                      prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks}
                                                    width={UtilidadeService.isMobile() ? 50 : 130} height={UtilidadeService.isMobile() ? 50 : 130}
                                                  />
                                                </Grid>
                                                <Grid size={{ xs: 9, sm: 8, md: 8 }} display="flex" justifyContent="center" alignItems="center" alignSelf="center" padding={1} >
                                                  {(prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2) && (
                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "80px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          {prop.tipo_Ativo === 1 ? prop.nome_Jogador : prop.nome_Jogador_Dispensa}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          R${prop.valor_Jogador !== undefined ? moedaRealLocaleValue(prop.valor_Jogador) : "0"}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          {prop.tempo_Contrato_Jogador !== undefined ? prop.tempo_Contrato_Jogador + " ano(s)" : "0 ano"}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 3 && prop.tipo_Multa !== 1 && (
                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "80px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={4}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Multa: {cab.nome_Franquia_Recebe}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Valor: {prop.valor_Multa !== undefined ? "R$ " + moedaRealLocaleValue(prop.valor_Multa) : prop.valor_Multa}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          Ano: {prop.descricao_Temporada_Multa}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 3 && prop.tipo_Multa === 1 && (
                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "80px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={4}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Multa: {cab.nome_Franquia_Recebe}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Jogador:  {prop.nome_Jogador_Multa?.split("-")[0]}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Valor:  {`${prop.nome_Jogador_Multa?.split("-")[1]} / ${prop.quantidade_Anos_Multa}`}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 4 && (
                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "80px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Pick: {prop.posicao_Final !== undefined && prop.posicao_Final > 2 ?
                                                            prop.posicao_Final
                                                            : prop.rodada_Pick !== undefined && prop.rodada_Pick === 1 ? "First" : "Second"}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          {"Ano: " + prop.ano_Pick}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          {prop.nome_Franquia_Recebe}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 5 && (
                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Melhor Pick: {prop.nome_Franquia_Recebe}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          Picks Envolvidas
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          * {prop.primeira_Pick_Swap}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          * {prop.terceira_Pick_Swap}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 6 && (
                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Melhor Pick: {prop.nome_Franquia_Recebe}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          Picks Envolvidas II
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          * {prop.primeira_Pick_Swap !== undefined ? prop.primeira_Pick_Swap : prop.rodada_Pick === 1 ? "First " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick : "Second " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          * {prop.segunda_Pick_Swap !== undefined ? prop.segunda_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap}
                                                        </Typography>
                                                        {prop.inicio_Protecao !== undefined && prop.inicio_Protecao > 0 && prop.fim_Protecao !== undefined && prop.fim_Protecao > 0 && (
                                                          <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                            {`* (${prop.inicio_Protecao} - ${prop.fim_Protecao})  ${prop.terceira_Pick_Swap !== undefined ? prop.terceira_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao}`}
                                                          </Typography>
                                                        )}
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 3 }} display={"flex"} justifyContent={"start"} style={{ marginTop: -25, paddingLeft: "5px" }}>
                                                  <img src={prop.logo_Franquia_Envia === null ? semImagem : prop.logo_Franquia_Envia} alt={prop.nome_Franquia_Envia} width={UtilidadeService.isMobile() ? 40 : 100} height={UtilidadeService.isMobile() ? 40 : 100} />
                                                </Grid>
                                              </Grid>
                                            </CardContent>
                                          </Grid>
                                        </Grid>
                                      </Card>
                                    </Grid>
                                  </Grid>
                                ))
                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" margin={2} >
                                  <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }} sx={{ color: "#CD1E03" }}>Esta franquia não possui itens a receber, nessa proposta. </Typography>
                                </Grid>
                              }
                            </Grid>
                          ))}
                        </Grid>
                      ) :
                      (
                        <Grid container spacing={2}  >
                          {lstDadosPropostaCabecalhoRecebe.map((cab, i) => (
                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} sx={{ backgroundColor: "#28292b" }} >
                              <Grid container size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1} margin={1} display="flex" direction="column" maxHeight={135}>
                                <Grid size={{ xs: 12, sm: 3 }} paddingLeft={1} paddingRight={1}>
                                  <img src={cab.logo_Franquia_Recebe}
                                    alt={cab.nome_Franquia_Recebe}
                                    width={130} height={130}
                                  />
                                </Grid>
                                <Grid container size={{ xs: 12, sm: 8 }} paddingLeft={1} paddingRight={1} width="92%">
                                  <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography variant='h5' style={{ fontSize: UtilidadeService.isMobile() ? 16 : 24 }} fontWeight="bold">
                                      {cab.nome_Franquia_Recebe}
                                    </Typography>
                                  </Grid>
                                  <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography variant='body1' style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                      {cab.nome_General_Manager_Recebe}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1}>
                                <hr />
                              </Grid>
                              {cab.dados_Propostas.filter(f => f.codigo_Franquia_Recebe === cab.codigo_Franquia_Recebe).length > 0
                                ? cab.dados_Propostas.filter(f => f.codigo_Franquia_Recebe === cab.codigo_Franquia_Recebe).map((prop, i) => (
                                  <Grid key={`Grid1${i}`} container size={{ xs: 12, sm: 12 }} display="flex" direction="row">
                                    <Grid key={`Grid${i}`} size={{ xs: 12, sm: 12, md: 12 }} margin={1} >
                                      <Card key={`Card${i}`} >
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                          <Grid size={{ xs: 12, sm: 3 }} alignSelf="center" padding={1}>
                                            <CardMedia
                                              component="img"
                                              alt={(prop.codigo_Franquia_Recebe + i).toString()}
                                              height={UtilidadeService.isMobile() ? 60 : 120}
                                              width={UtilidadeService.isMobile() ? 60 : 150}
                                              image={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks
                                              }
                                              key={`CardMedia${i}`}
                                              sx={{ objectFit: "fill" }}
                                            />
                                          </Grid>
                                          <Grid size={{ xs: 12, sm: 9 }}>
                                            <CardContent sx={{ padding: 1, paddingBottom: 1 }} >
                                              <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                <Grid size={{ xs: 12, sm: 9, md: 9 }} display="flex" justifyContent="center" alignItems="center" alignSelf="center" padding={1} >
                                                  {(prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2) && (
                                                    <Box width="100%" height="150px" display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          {prop.tipo_Ativo === 1 ? prop.nome_Jogador : prop.nome_Jogador_Dispensa}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={3}>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                          R${prop.valor_Jogador !== undefined ? moedaRealLocaleValue(prop.valor_Jogador) : "0"}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                          {prop.tempo_Contrato_Jogador !== undefined ? prop.tempo_Contrato_Jogador + " ano(s)" : "0 ano"}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 3 && prop.tipo_Multa !== 1 && (
                                                    <Box width="100%" height="150px" display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={4}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Multa: {cab.nome_Franquia_Recebe}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Valor: {prop.valor_Multa !== undefined ? "R$ " + moedaRealLocaleValue(prop.valor_Multa) : prop.valor_Multa}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                          Ano: {prop.descricao_Temporada_Multa}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 3 && prop.tipo_Multa === 1 && (
                                                    <Box width="100%" height="150px" display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={4}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Multa: {cab.nome_Franquia_Recebe}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Jogador:  {prop.nome_Jogador_Multa?.split("-")[0]}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Valor:  {`${prop.nome_Jogador_Multa?.split("-")[1]} / ${prop.quantidade_Anos_Multa}`}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 4 && (
                                                    <Box width="100%" height="150px" display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Pick: {prop.posicao_Final !== undefined && prop.posicao_Final > 2 ?
                                                            prop.posicao_Final
                                                            : prop.rodada_Pick !== undefined && prop.rodada_Pick === 1 ? "First" : "Second"}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          {"Ano: " + prop.ano_Pick}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                          {prop.nome_Franquia_Recebe}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 5 && (
                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Melhor Pick: {prop.nome_Franquia_Recebe}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          Picks Envolvidas
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          * {prop.primeira_Pick_Swap}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          * {prop.terceira_Pick_Swap}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                  {prop.tipo_Ativo === 6 && (
                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                      <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                          Melhor Pick: {prop.nome_Franquia_Recebe}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          Picks Envolvidas II
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          * {prop.primeira_Pick_Swap !== undefined ? prop.primeira_Pick_Swap : prop.rodada_Pick === 1 ? "First " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick : "Second " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick}
                                                        </Typography>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                          * {prop.segunda_Pick_Swap !== undefined ? prop.segunda_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap}
                                                        </Typography>
                                                        {prop.inicio_Protecao !== undefined && prop.inicio_Protecao > 0 && prop.fim_Protecao !== undefined && prop.fim_Protecao > 0 && (
                                                          <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                            {`* (${prop.inicio_Protecao} - ${prop.fim_Protecao})  ${prop.terceira_Pick_Swap !== undefined ? prop.terceira_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao}`}
                                                          </Typography>
                                                        )}
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                          {prop.nome_Franquia_Envia} ENVIA
                                                        </Typography>
                                                      </Grid>
                                                    </Box>
                                                  )}
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 3 }}>
                                                  <Grid size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" justifySelf="center" alignItems="center">
                                                    <img src={prop.logo_Franquia_Envia === null ? semImagem : prop.logo_Franquia_Envia} alt={prop.nome_Franquia_Envia} width={100} height={100} />
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </CardContent>
                                          </Grid>
                                        </Grid>
                                      </Card>
                                    </Grid>
                                  </Grid>
                                ))
                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" margin={2} >
                                  <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }} sx={{ color: "#CD1E03" }}>Esta franquia não possui itens a receber, nessa proposta. </Typography>
                                </Grid>
                              }
                            </Grid>
                          ))}
                        </Grid>
                      )
                    : (<Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                      <Typography variant="h6">Nenhuma proposta encontrada </Typography>
                      <hr />
                    </Grid>
                    )
                  }
                </TabPanel>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Fechar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  )
};